<template>
  <div class="footer-wrap">
    <div class="footer">
      <div class="edg_bottom">
        <div class="table">
          <div class="flex flex1">
            <div class="edg_bottom-title">关于我们</div>
            <ul>
              <li><router-link to="/index/qyjs">公司介绍</router-link></li>
              <li><router-link to="/index/xwdt">新闻动态</router-link></li>
              <li><router-link to="/index/lxwm">联系我们</router-link></li>
            </ul>
          </div>
          <div class="flex flex222">
            <div class="edg_bottom-title">服务条款</div>
            <ul>
              <li v-for="(fw, index) in fwtk" :key="index">
                <a :href="fw.fileUrl" target="_blank">{{ fw.title }}</a>
              </li>
            </ul>
          </div>
          <div class="flex flex222">
            <div class="edg_bottom-title">友情链接</div>
            <ul>
              <li v-for="(yq, index) in yqlj" :key="index">
                <a :href="yq.linkUrl" target="_blank">{{ yq.linkName }}</a>
              </li>
            </ul>
          </div>
          <div class="flex flex333">
            <div class="edg_bottom-title">技术文档</div>
            <ul>
              <!-- <li><a href='../video/汇集器安装视频.mp4' target="_blank" download="汇集器安装视频.mp4">安装视频mp4</a></li> -->
              <li v-for="(js, index) in jswd" :key="index">
                <a :href="js.fileUrl" target="_blank">{{ js.title }}</a>
              </li>
            </ul>
          </div>
          <div class="flex flex2">
            <div class="edg_bottom-title">投诉咨询</div>
            <ul class="imglogo">
              <li class="tel">4008-263-365</li>
              <li class="tel">投诉电话</li>
              <li class="tel">0571-86779590</li>
              <li class="erweima">
                <!-- <img src="../../assets/img/erweima-logo2.jpg" alt="" class="ewcode"> -->
              </li>
            </ul>
          </div>
          <div class="flex flex2">
            <div class="edg_bottom-title">关注我们</div>
            <ul class="imglogo">
              <li class="erweima">
                <img
                  src="../../assets/img/erweima-logo2.jpg"
                  alt=""
                  class="ewcode"
                />
              </li>
            </ul>
          </div>
        </div>
        <div class="line"></div>
        <div class="edg_record">
          <div>
            备案信息：浙B2-20090014 || 中国 • 杭州湖墅南路332号新能量大楼
          </div>
          <div>
            Copyright © 2004 Freshpower.cn.All rights Reserved | 新能量 |
            能监宝-智能能源监测平台
          </div>
          <div>
            <div>
              <p class="icon-public"></p>
              <a
                href=" http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010502002132"
                target="_blank"
                >公安备案号：33010502002132</a
              >
            </div>
            <div>
              <p class="icon-gxb"></p>
              <a href="http://www.beian.miit.gov.cn/" target="_blank"
                >工信部备案号：浙B2-20090014-4</a
              >
            </div>
          </div>
          <div>网站运营：浙江新能量科技股份有限公司</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "foter",
  data() {
    return {
      fwtk: "",
      jswd: "",
      fileId: "",
      yqlj: ""
    };
  },
  mounted() {
    this.fwtkInfo();
    this.jswdInfo();
    this.yqljInfo();
  },
  methods: {
    // 服务条款
    fwtkInfo() {
      axios
        .post(
          `${this.global.baseUrl}/news/listPortalContent?pageIndex=1&pageSize=4&columnId=0a59dc8e54d54d6ea73142c666fd08df`,
          {}
        )
        .then(response => {
          if (response.data.code === 1) {
            this.fwtk = response.data.data.items;
          } else if (response.data.code === 0) {
            this.$message.info(response.data.msg);
          } else if (response.data.code === -1) {
            this.$message.error(response.data.msg);
          }
        });
    },
    // 技术文档
    jswdInfo() {
      axios
        .post(
          `${this.global.baseUrl}/news/listPortalContent?pageIndex=1&pageSize=4&columnId=b298ada29c6b45ab884adbd081a341a7`,
          {}
        )
        .then(response => {
          if (response.data.code === 1) {
            this.jswd = response.data.data.items;
          } else if (response.data.code === 0) {
            this.$message.info(response.data.msg);
          } else if (response.data.code === -1) {
            this.$message.error(response.data.msg);
          }
        });
    },
    // 友情链接
    yqljInfo() {
      axios
        .post(
          `${this.global.baseUrl}/news/listPortalLink?pageIndex=1&pageSize=4`,
          {}
        )
        .then(response => {
          if (response.data.code === 1) {
            this.yqlj = response.data.data.items;
          } else if (response.data.code === 0) {
            this.$message.info(response.data.msg);
          } else if (response.data.code === -1) {
            this.$message.error(response.data.msg);
          }
        });
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/common/footerend.vue